import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PaymentTypeServices = {
  getList: async () => {
    const response = await apiService.get("/paymenttypes");
    return response.data;
  },

  create: async (formData) => {
    try {
      const response = await apiService.post(`/paymenttypes`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating payment type:", error);
      throw error;
    }
  },

  update: async (id, formData) => {
    try {
      const response = await apiService.put(`/paymenttypes/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating payment type:", error);
      throw error;
    }
  },

  delete: async (id) => {
    const response = await apiService.delete(`/paymenttypes/${id}`);
    return response.data;
  },

  onlineOrderPaymentTypeGetList: async (token, orgcode) => {
    const response = await apiService.get("/paymenttypes/online-ordering", {
      headers: {
        APIKEY: orgcode,
        Authorization: "Bearer " + token,
      },
    });
    return response.data;
  },
};

export default PaymentTypeServices;
